/*
 * Decimal, Account Management App.
 * Copyright (C) 2008-2013 Decimal
 * mailto:contact AT decimal DOT co DOT in
 *
 * Account is Decimal software; you can not redistribute it.
 * any versions of the License.
 * License is private by the Decimal Foundation;
 *
 * Inc., 8th Floor, Tower – D, Pioneer Urban Square, Golf Course Ext Rd,
 * Sector 62, Gurugram, Haryana 122102
 */
import { Location } from '@angular/common';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject, Subject } from 'rxjs';
import { path } from 'src/environments/config';
import { environment } from 'src/environments/environment';
import { MatSnackBar } from '@angular/material/snack-bar';

const COOKIETIMEOUT = '60 * 60 * 24 * 1000';
const USER_ID = 'USER_ID';
const USERNAME = 'USERNAME';
const ACCOUNT_ID = 'ACCOUNT_ID';
const DEFAULT_ACCOUNT_ID = 'DEFAULT_ACCOUNT_ID';
const DEFAULT_WORKSPACE = 'DEFAULT_WORKSPACE';
const ACCESS_LEVEL = 'ACCESS_LEVEL';
const DEFAULT_ACCOUNT_NAME = 'DEFAULT_ACCOUNT_NAME';
const APP_ID = 'APP_ID';
const APP_TYPE = 'APP_TYPE';
const MODULE_ID = 'MODULE_ID';
const BRANCH_ID = 'BRANCH_ID';
const WORKSPACE_NAME = 'WORKSPACE_NAME';
const DEFAULT_ACCOUNT_USER_ROLE = 'DEFAULT_ACCOUNT_USER_ROLE';
const DEFAULT_ACCOUNT_HIERARCHY = 'DEFAULT_ACCOUNT_HIERARCHY';
/**
 * CookieService
 * cookietimeout
 * environment variables
 */

/**
 * UtilityService
 */

@Injectable({
  providedIn: 'root',
})
export class UtilityService {
  workspaceList;
  public isLeftMenuOpen = false;
  public isRightMenuOpen = false;
  public worksapce1;
  public newWorkSpaceName;
  public createdAppdata;
  public workspacelist = [];
  public orgname;
  public selectedapps = null;
  public destinationAppId = '';
  public destinationOrgId = '';
  public userData;
  workspaceData: Subject<object> = new BehaviorSubject<object>(null);
  loader: Subject<boolean> = new BehaviorSubject<boolean>(false);
  profileClicked: Subject<boolean> = new BehaviorSubject<boolean>(false);
  paginationObj = {"pageNumber":0, "pageLimit":50};

  modules = {
    'console': {},
    'account': {},
    'app-home': {},
    'app-development': {},
    'app-setting':{},
    'app-build':{},
    'config':{},
    'designer': {},
    'data-modeler': {},
    'themes': {},
    'middleware': {},
    'vacademy': {},
    'vflow':{},
    'community':{},
    'home-applicationList':{}
  }
  isNotificationPanelVisible: boolean;
  NotificationVisibilityEmitter = new BehaviorSubject<any>(null);
  childEmitter = new BehaviorSubject<any>(null);
  appSubType:Subject<any> = new BehaviorSubject<any>(null);
  selectedModule: Subject<any> = new BehaviorSubject<any>(null);
  selectedWorkspaceName: any;
  orgID: any;
  selectedImage : Subject<any> = new BehaviorSubject<any>(null);



  /**
   * Initilizes UtilityService
   * @param snackBar;
   * @returns void;
   */
  constructor(
    private readonly snackBar: MatSnackBar,
    private readonly router: Router,
    private location: Location,
  ) {
    window.addEventListener('message', (message) => {
      if (message.data.eventType === 'PROFILECLICK')
        this.sendEvent();
    });
    this.setupModules();
  }

  /**
   * setCookie
   * @param name:
   * @param value:
   * @returns void
   * setcookie
   * environment values
   * domain
   */
  setCookie(name: string, value: string): void {
    document.cookie = `${name}=${value};domain=${environment.cookieDomain};path=/;samesite=lax;secure: true;max-age: ${COOKIETIMEOUT}`;
  }

  /**
   * getCookie
   * getcookie
   * environmentvalues
   * domain
   */
  getCookie(name: string): string | null {
    name = name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1');
    const matches = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
    return matches ? matches[2] : null;
  }

  sendEvent() {
    this.profileClicked.next(true);
  }

  /**
   * remove
   * @param name;
   * @returns void
   * remove cookie
   */
  remove(name: string): void {
    document.cookie = `${name}=;domain=${environment.cookieDomain};path=/;samesite=lax;secure: true;max-age:-1`;
  }

  getUserId() {
    return this.getCookie(USER_ID);
  }

  getWorkspaceName() {
    return this.getCookie(WORKSPACE_NAME);
  }

  getAppType() {
    return this.getCookie(APP_TYPE);
  }

  storeData(key: string, value: any) {
    window.localStorage.setItem(key, JSON.stringify(value));
  }

  getUserName() {
    return this.getCookie(USERNAME);
  }

  getAccountId() {
    return this.getCookie(ACCOUNT_ID);
  }

  getAppId() {
    return this.getCookie(APP_ID);
  }

  getUserRole() {
    return this.getCookie(DEFAULT_ACCOUNT_USER_ROLE)
  }

  getDefaultAccountId() {
    return this.getCookie(DEFAULT_ACCOUNT_ID);
  }

  getDefaultAccountHierarchy() {
    return this.getCookie(DEFAULT_ACCOUNT_HIERARCHY);
  }

  getModuleId(){
    return this.getCookie(MODULE_ID);
  }

  getBranchId(){
    return this.getCookie(BRANCH_ID);
  }

  getDefaultWorkspace() {
    return this.getCookie(DEFAULT_WORKSPACE);
  }

  getWorkspaceAccessLevel() {
    return this.getCookie(ACCESS_LEVEL);
  }

  getWorkspaceId() {
    const accessLevel = this.getCookie(ACCESS_LEVEL);
    return accessLevel.split(':')[1].split('_')[0];
  }

  // getWorkspaceName() {
  //   return this.getCookie(WORKSPACE_NAME);
  // }

  showLoader() {
    this.loader.next(true);
  }

  hideLoader(interval?) {
    setTimeout(() => {
      this.loader.next(false);
    }, interval || 400);
  }
  /**
   * openSnackBar
   * @param message;
   * @param actionClass;
   */
  openSnackBar(message: string, actionClass?: string) {
    const actionBtn = 'Close';
    if (!message) {
      this.showSnackBar('Message is not defined', actionBtn);
    } else {
      this.showSnackBar(message, actionBtn, actionClass);
    }
  }

  getQueryParamsToObj(parameter: string) {
    const data = {};
    const params = parameter.split('&');
    params.forEach((ele) => {
      const value = ele.split('=');
      data[value[0]] = value[1];
    });
    return data;
  }

  getUrlQueryParam() {
    const url = window.location.href;
    if (url.includes('?')) {
      const param = url.split('?')[1];
      const queryParam = this.getQueryParamsToObj(param);
      return queryParam;
    }
    return;
  }

  getObjToQueryParam(obj): string {
    const arr = [];
    // tslint:disable-next-line: forin
    for (const key in obj) {
      const value = `${key}=${obj[key]}`;
      arr.push(value);
    }
    let queryString;
    if (arr.length > 1) {
      queryString = arr.toString().replace(/,/g, '&');
    } else {
      queryString = arr.toString();
    }
    return queryString;
  }

  getCodeValue(code, list) {
    return list.find((ele) => ele.code === code).value;
  }

  getValueCode(value, list) {
    return list.find((ele) => ele.value === value).code;
  }

  goBack() {
    this.location.back();
  }
  setWorkspaceData(data) {
    this.workspaceData.next(data);
  }
  workspaceName;
  setWorkSpaceName(wrkSpcName){
    this.workspaceName = wrkSpcName;
  }

  getWorkSpaceName(){
    return this.workspaceName;
  }

  /**
   * showSnackBar
   * @param msg:
   * @param action:
   * @param classRequired:
   * @returns void
   */
  showSnackBar(msg: string, action, classRequired?): void {
    const WAITTIME = 4000;
    this.snackBar.open(msg, action, {
      duration: WAITTIME,
      panelClass: [classRequired],
    });
  }

  /**
   * navigateTo
   * @param path;
   * @param queryParam;
   */
  navigateTo(path: string, queryParam?: object) {
    this.router.navigate([path], {
      queryParams: queryParam,
      queryParamsHandling: 'merge',
      skipLocationChange: false,
    });
  }

  /**
   * apiError
   * @param res;
   */
  apiError(res) {
    if (res && res.message) {
      this.openSnackBar(res.message);
    } else {
      this.openSnackBar(
        'Something went wrong!'
      );
    }
  }

  setIframesUrls() {
    // JavaScript to set the src attributes dynamically
    (document.getElementById('appframe') as HTMLIFrameElement).src = `${environment.appManagementUrl.split('#')[0]}assets/frame/application-frame.html?data=1`;
    (document.getElementById('accountframe') as HTMLIFrameElement).src = `${environment.accountManagementUrl.split('#')[0]}assets/frame/account-frame.html?data=1`;
    (document.getElementById('themesframe') as HTMLIFrameElement).src = `${environment.themes.split('#')[0]}assets/frame/themesframe.html?data=1`;
    (document.getElementById('datamodelerframe') as HTMLIFrameElement).src = `${environment.datamodeler.split('#')[0]}assets/frame/data-modeler.html?data=1`;
    (document.getElementById('designerframe') as HTMLIFrameElement).src = `${environment.vdesignerUrl.split('#')[0]}assets/frame/designer-frame.html?data=1`;
    (document.getElementById('itops-analytics') as HTMLIFrameElement).src = `${environment.itopsanalyticsUrl.split('#')[0]}assets/frame/itops-analytics-frame.html?data=1`;
    (document.getElementById('itops-observability') as HTMLIFrameElement).src = `${environment.itopsObservabilityUrl.split('#')[0]}assets/frame/itops-observability-frame.html?data=1`;
    (document.getElementById('itops-appops') as HTMLIFrameElement).src = `${environment.itopsAppopsUrl.split('#')[0]}assets/frame/itops-appops-frame.html?data=1`;
    (document.getElementById('iamframe') as HTMLIFrameElement).src = `${environment.iamurl.split('#')[0]}assets/frame/iam-frame.html?data=1`;
    (document.getElementById('api-gateway') as HTMLIFrameElement).src = `${environment.apiGatewayUrl.split('#')[0]}assets/frame/api-gateway-frame.html?data=1`;
  }

  broadcast(msg) {
    // const iframe: HTMLIFrameElement = <HTMLIFrameElement>document.getElementById('appframe');
    // iframe.contentWindow.postMessage(msg, "*");
    const microfrontendiframes = [
      {
        id: 'appframe',
        target: `${environment.appManagementUrl.split('#')[0]}`
      },
      {
        id: 'accountframe',
        target: `${environment.accountManagementUrl.split('#')[0]}`
      },
      {
        id: 'themesframe',
        target: `${environment.themes.split('#')[0]}`
      },
      {
        id: 'datamodelerframe',
        target: `${environment.datamodeler.split('#')[0]}`
      },
      {
        id: 'designerframe',
        target: `${environment.vdesignerUrl.split('#')[0]}`
      },
      {
        id: 'itops-analytics',
        target: `${environment.itopsanalyticsUrl.split('#')[0]}`
      },
      {
        id: 'itops-observability',
        target: `${environment.itopsObservabilityUrl.split('#')[0]}`
      },
      {
        id: 'itops-appops',
        target: `${environment.itopsAppopsUrl.split('#')[0]}`
      },
      {
        id: 'iamframe',
        target: `${environment.iamurl.split('#')[0]}`
      },
      {
        id: 'api-gateway',
        target: `${environment.apiGatewayUrl.split('#')[0]}`
      },

    ];
    microfrontendiframes.forEach((iframe: any) => (document.getElementById(iframe.id) as HTMLIFrameElement).contentWindow.postMessage(msg, iframe.target));

    // const microfrontendiframes = ['appframe', 'accountframe', 'themesframe', 'datamodelerframe', 'designerframe'];
  }

  setupModules() {

    this.modules['account']['title'] = 'AccountManagement-' + path;
    this.modules['account']['url'] = environment.accountMangUrl;

    this.modules['app-home']['title'] = 'Applications-' + path;
    this.modules['app-home']['url'] = environment.applicationsDashboard;

    this.modules['app-development']['title'] = 'App-Development-' + path;
    this.modules['app-development']['url'] = environment.appDashboard;

    this.modules['app-setting']['title'] = 'App-Development-' + path;
    this.modules['app-setting']['url'] = environment.appSetting;

    this.modules['app-build']['title'] = 'App-Development-' + path;
    this.modules['app-build']['url'] = environment.downloadUrl;

    this.modules['config']['title'] = 'Config-' + path;
    this.modules['config']['url'] = environment.ConfigDashboardUrl;

    this.modules['designer']['title'] = 'Designer-' + path;
    this.modules['designer']['url'] = environment.vdesignerUrl;

    this.modules['vflow']['title'] = 'Designer-' + path;
    this.modules['vflow']['url'] = environment.vFlowUrl;

    this.modules['data-modeler']['title'] = 'DataModeler';
    this.modules['data-modeler']['url'];

    this.modules['themes']['title'] = 'DesignSystem';
    this.modules['themes']['url'] = environment.themesUrl;

    this.modules['middleware']['title'] = 'Middleware-' + path;
    this.modules['middleware']['url'] = environment.vahana1url + 'login/#/authentication/signIn/sign-in';

    this.modules['vacademy']['title'] = 'vAcademy-' + path;
    this.modules['vacademy']['url'] = `${environment.vAcademyUrl}`

    this.modules['community']['title'] = 'Community-' + path;
    this.modules['community']['url'] = `${environment.communityUrl}`

    this.modules['home-applicationList']['title'] = 'homeApplications-' + path;
    this.modules['home-applicationList']['url'] = `${environment.homeApplicationListUrl}`
  }

  getAppOpenUrl(appData?, subType?) {
    const candidates = [subType, appData?.subType, appData?.appType, appData?.type];
    const isCustom = candidates.some(
      (value) => (value ?? '').toString().toLowerCase() === 'custom'
    );
    // Custom apps open dashboard only; all other types keep development.
    if (isCustom) {
      return this.modules['app-setting']['url'];
    }
    return this.modules['app-development']['url'];
  }

  getAppSubType(app) {
    switch (app?.subType?.toLowerCase()) {
      case 'web':
        return 'Web - vFlow';
      case 'backend':
      case 'middleware':
        return 'Middleware';
      case 'workflow':
        return 'Agentic Workflow';
      case 'custom':
        return 'Custom';
      case 'smartdesk':
        return 'Smart Desk';
      case 'policyapps':
        return 'GateX';
      case 'objectmodeler':
        return 'Object Modeler';
      case 'mobile':
        return app?.appProperties?.canvasSize === 'large' ? 'Web - vDesigner' : 'Mobile - vDesigner';
      default:
        return app?.subType?.slice(0,1) + app?.subType?.slice(1)?.toLowerCase();
    }
  }

  getAppSubTypeClass(app) {
    switch (app?.subType?.toLowerCase()) {
      case 'web':
        return 'success';
      case 'mobile':
        return app?.appProperties?.canvasSize === 'large' ? 'warning' : 'progress';
      default:
        return 'information';
    }
  }
}
